module.exports = __webpack_public_path__ + "img/profile04.655107b5.jpg";